
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import LIST_CONNECTIONS from "@/apollo/company/ListConnections.gql";
import CHECK_CONVERSATIONS from "@/apollo/conversations/CheckConversations.gql";

import ConnectionTableItem from "@/components/network/ConnectionTableItem.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import TableContainer from "@/components/table/table-container.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

import { Query_RootUserArgs, Conversation, User } from "@/generated/graphql";
import paginationConfig from "@/data/paginationConfig";
import PaginationConfig from "@/entities/PaginationConfig";
import EmptyListImageConnections from "@/components/icons/emptyListImages/EmptyListImageConnections.vue";

interface TableConfig extends PaginationConfig  {
  query: string,
  headers: string[],
  columns: string[],
}

@Component({
  components: {
    EmptyListImageConnections,
    ConnectionTableItem,
    EmptyListPlaceholder,
    LoadingOverlay,
    TableContainer,
  },
  apollo: {
    connections: {
      query: LIST_CONNECTIONS,
      variables() {
        return this.connectionArgs;
      },
      update(data) {
        this.config.total = data.total.aggregate.count;
        this.config.loadedCount = data.user.length;
        return data.user;
      },
    },
    $subscribe: {
      connectionsList: {
        query: CHECK_CONVERSATIONS,
        variables() {
          return {
            currentUserId: this.currentUser.id,
            where: {user_id: { _eq: this.currentUser.id}},
          };
        },
        result(response: any) {
          //@ts-ignore
          this.conversationsUpdated = response.data.user_conversation;
        },
      }
    }
  },
})
export default class Connections extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  connections?: User[] = undefined;
  conversationsUpdated: Conversation[] = [];

  @Watch('conversationsUpdated')
  async onConversationsUpdated() {
    if (!this.conversationsUpdated.length) {
      return;
    }
    await this.$apollo.queries.connections.refetch();
  }

  get contractorConnections(): User[] {
    if (!this.connections) {
      return [];
    }
    return this.connections;
  }

  config: TableConfig = {
    ...paginationConfig,
    query: "",
    headers: ["User", "Company", "Role"],
    columns: [],
  };

  get empty(): boolean {
    if (!this.connections) {
      return false;
    }

    return this.contractorConnections.length === 0;
  }

  get connectionArgs(): Query_RootUserArgs {
    const { page, limit } = this.config;
    const nextOffset = page * limit - limit;

    return {
      offset: nextOffset,
      limit: limit,
      where: {
        _and: [
          {
            conversations: {
              _and: [
                { deleted: { _eq: false } },
                { conversation: {
                  users: {
                    _and: [
                      { deleted: { _eq: false } },
                      { user_id: { _eq: this.currentUser.id } }
                    ]
                  }
                }}
              ]
            }
          },
          { id: { _neq: this.currentUser.id } },
          { role: { _in: ["ADMIN", "MANAGER"] } }
        ]
      },
    };
  }
}
